import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { isArray } from 'lodash';

import { useToast } from 'Store/toast';
import patchRequestApproval from 'Api/reschedule/patchRequestApproval';
import { useLoader } from 'Store/loader';

const usePatchRequestApproval = () => {
  const { t } = useTranslation('reschedule');
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { onOpenToast, onResetToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationFn: async ({ id, statusProgress }) => {
      onShowLoader({ variant: 'loader-primary' });
      return await patchRequestApproval(id, statusProgress);
    },
    onSuccess: (_, { statusProgress }) => {
      onOpenToast({
        status: 'success',
        description: statusProgress === 'Diterima' ? t('approveSuccess') : t('rejectSuccess'),
        duration: 5,
        alwaysShow: false,
      });

      queryClient.invalidateQueries({ queryKey: ['request-approval'] });
      queryClient.invalidateQueries({ queryKey: ['request-approval-by-id'] });

      navigate('/schedule/approval-reschedule');
    },
    onError: (error, { statusProgress }) => {
      const errorMessage = isArray(error?.response?.data?.errors)
        ? error?.response?.data?.errors[0]?.message
        : statusProgress === 'Diterima'
        ? t('approveError')
        : t('rejectError');

      onOpenToast({
        status: 'error',
        title: t('approveErrorTitle'),
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
      onResetToast();
    },
  });
};

export default usePatchRequestApproval;
